module.exports = __webpack_public_path__ + "static/img/logo10.b6d3024.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo10.png
// module id = ZvIG
// module chunks = 1